import { useState } from "react";

import DratCauseList from "./DratCauseList";
import DrtCauseList from "./DrtCauseList";
import RcCauseList from "./RcCauseList";

const CauseListHome = () => {
  const [relatedLink, setRelatedLink] = useState("DRT Cause List");

  return (
    <div>
      <div className="row">
        {/* ---- LEFT SIDE NAV ---- */}
        <div
          className="col-12 col-sm-12 col-md-12 col-lg-4 p-0"
          role="region"
          aria-label="Cause List Navigation"
        >
          <ul className="nav toptab-two mb-3" id="cause-tablist" role="tablist">
            {/* --- DRT Cause List --- */}
            <li className="nav-item" role="presentation">
              <a
                href="#pane-drt"
                id="tab-drt"
                className={
                  relatedLink === "DRT Cause List"
                    ? "nav-link active"
                    : "nav-link"
                }
                role="tab"
                aria-controls="pane-drt"
                aria-selected={relatedLink === "DRT Cause List"}
                data-bs-toggle="pill"
                onClick={(e) => {
                  e.preventDefault();
                  setRelatedLink("DRT Cause List");
                }}
              >
                DRT Cause List
              </a>
            </li>

            {/* --- RC Cause List --- */}
            <li className="nav-item" role="presentation">
              <a
                href="#pane-rc"
                id="tab-rc"
                className={
                  relatedLink === "RC Cause List"
                    ? "nav-link active"
                    : "nav-link"
                }
                role="tab"
                aria-controls="pane-rc"
                aria-selected={relatedLink === "RC Cause List"}
                data-bs-toggle="pill"
                onClick={(e) => {
                  e.preventDefault();
                  setRelatedLink("RC Cause List");
                }}
              >
                RC Cause List
              </a>
            </li>

            {/* --- DRAT Cause List --- */}
            <li className="nav-item" role="presentation">
              <a
                href="#pane-drat"
                id="tab-drat"
                className={
                  relatedLink === "DRAT Cause List"
                    ? "nav-link active"
                    : "nav-link"
                }
                role="tab"
                aria-controls="pane-drat"
                aria-selected={relatedLink === "DRAT Cause List"}
                data-bs-toggle="pill"
                onClick={(e) => {
                  e.preventDefault();
                  setRelatedLink("DRAT Cause List");
                }}
              >
                DRAT Cause List
              </a>
            </li>
          </ul>
        </div>

        {/* ---- RIGHT SIDE CONTENT ---- */}
        <div className="col-12 col-sm-12 col-md-12 col-lg-8 pr-0">
          <div className="tab-content tab-form" id="cause-tabContent">
            <div
              id="pane-drt"
              role="tabpanel"
              aria-labelledby="tab-drt"
              className={`tab-pane fade ${
                relatedLink === "DRT Cause List" ? "show active" : ""
              }`}
            >
              <DrtCauseList />
            </div>

            <div
              id="pane-rc"
              role="tabpanel"
              aria-labelledby="tab-rc"
              className={`tab-pane fade ${
                relatedLink === "RC Cause List" ? "show active" : ""
              }`}
            >
              <RcCauseList />
            </div>

            <div
              id="pane-drat"
              role="tabpanel"
              aria-labelledby="tab-drat"
              className={`tab-pane fade ${
                relatedLink === "DRAT Cause List" ? "show active" : ""
              }`}
            >
              <DratCauseList />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CauseListHome;
